"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddNewAdminMethodRequest = exports.AddNewAdminSchema = void 0;
const yup = __importStar(require("yup"));
const ValidationError_1 = require("../errors/ValidationError");
const User_1 = require("./User");
/**
 * Schema for add new admin method validation
 * {@link IAddNewAdminRequestBody}
 */
const AddNewAdminSchema = yup.object().shape({
    firstName: User_1.UserSchema.firstName,
    secondName: User_1.UserSchema.secondName,
    familyName: User_1.UserSchema.familyName,
    email: yup.string().email().required("Please enter email").max(255),
    roles: yup
        .array()
        .of(yup.string().oneOf(["ADMIN", "APPROVER"], "Invalid role"))
        .min(1, "At least one role is required")
        .default(["ADMIN"]),
});
exports.AddNewAdminSchema = AddNewAdminSchema;
/**
 * Validates add new admin method request schema
 * @param data: add new admin method request {@link IAddNewAdminRequestBody} to validate
 */
const validateAddNewAdminMethodRequest = async (data) => {
    try {
        await AddNewAdminSchema.validate(data, {
            abortEarly: false,
        });
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
};
exports.validateAddNewAdminMethodRequest = validateAddNewAdminMethodRequest;
//# sourceMappingURL=AddNewAdmin.js.map